import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "_tc--accent _mt-3"
}
const _hoisted_2 = { "format-key": "0" }
const _hoisted_3 = {
  key: 0,
  class: "_tc--accent _mt-3"
}
const _hoisted_4 = { "format-key": "0" }
const _hoisted_5 = { class: "gfu-bt gfu-bt--caption" }
const _hoisted_6 = {
  "format-key": "0",
  class: "gfu-comment-badge"
}
const _hoisted_7 = { "format-key": "1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_localize = _resolveComponent("localize")
  const _component_project_comment_item = _resolveComponent("project-comment-item")
  const _component_base_button = _resolveComponent("base-button")
  const _component_project_comment_field = _resolveComponent("project-comment-field")

  return (_openBlock(), _createBlock(_component_project_comment_item, _mergeProps({ ...$props.thread, ...$setup.listeners }, {
    ref: "mainThreadComment",
    class: _ctx.$attrs.class,
    "has-children": $props.thread.children.length > 0,
    "has-pin-comment-action": $props.hasPinCommentAction,
    "has-report-and-hide-action": $props.hasReportAndHideAction,
    "allow-creator-hiding-comments": $props.allowCreatorHidingComments,
    "is-breakpoint-large": $options.isBreakpointLarge,
    "can-comment": $props.canComment,
    onReply: $options.onReply,
    onNicknameRequired: $options.onNicknameRequired,
    onTagSelected: $options.onTagSelected,
    "data-qa": `project-comment:${$props.thread.commentID}`
  }), {
    default: _withCtx(() => [
      _createVNode(_Transition, { name: "gfu-fade" }, {
        default: _withCtx(() => [
          (!!$options.countLoadMoreComments)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("a", {
                  href: "",
                  onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($options.onloadMoreChildren(false)), ["prevent"])),
                  "data-qa": "project-comment-action:LoadMore"
                }, [
                  _createVNode(_component_base_icon, {
                    name: "ellipsis-v",
                    class: "_mr-1"
                  }),
                  (_openBlock(), _createBlock(_component_localize, {
                    key: $options.countLoadMoreComments,
                    resource: _ctx.Resources.Comments.LoadMoreChildCommentsButton
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_2, _toDisplayString($options.countLoadMoreComments), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["resource"]))
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.children, (childrenComment) => {
        return (_openBlock(), _createBlock(_component_project_comment_item, _mergeProps({ ref_for: true }, { ...childrenComment, ...$setup.listeners }, {
          ref_for: true,
          ref: "childrenComments",
          key: childrenComment.commentID,
          class: "_mt-3",
          "is-breakpoint-large": $options.isBreakpointLarge,
          "has-report-and-hide-action": $props.hasReportAndHideAction,
          "allow-creator-hiding-comments": $props.allowCreatorHidingComments,
          "can-comment": $props.canComment,
          onReply: $options.onReply,
          "data-qa": `project-comment:${childrenComment.commentID}`
        }), null, 16 /* FULL_PROPS */, ["is-breakpoint-large", "has-report-and-hide-action", "allow-creator-hiding-comments", "can-comment", "onReply", "data-qa"]))
      }), 128 /* KEYED_FRAGMENT */)),
      _createVNode(_Transition, { name: "gfu-fade" }, {
        default: _withCtx(() => [
          (!!$props.thread.newerChildrenCount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("a", {
                  href: "",
                  onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($options.onloadMoreChildren(true)), ["prevent"])),
                  "data-qa": "project-comment-action:LoadMore"
                }, [
                  _createVNode(_component_base_icon, {
                    name: "ellipsis-v",
                    class: "_mr-1"
                  }),
                  (_openBlock(), _createBlock(_component_localize, {
                    key: $props.thread.newerChildrenCount,
                    resource: _ctx.Resources.Comments.LoadMoreChildCommentsButton
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_4, _toDisplayString($props.thread.newerChildrenCount), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["resource"]))
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_Transition, { name: "gfu-fade" }, {
        default: _withCtx(() => [
          ($props.thread.newRepliesCount > 0)
            ? (_openBlock(), _createBlock(_component_base_button, {
                key: 0,
                theme: "lightAlt",
                shape: "hard",
                display: "block",
                shadow: "tight",
                width: "tight",
                class: "_mt-3 _mb-3",
                onClick: _cache[2] || (_cache[2] = $event => ($options.onloadMoreChildren(true))),
                "data-qa": "project-comment-button:LoadMore"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_5, [
                    (_openBlock(), _createBlock(_component_localize, {
                      key: $props.thread.newRepliesCount,
                      resource: _ctx.Resources.Comments.LoadNewMessagesButton
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_6, _toDisplayString($props.thread.newRepliesCount), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_7, _toDisplayString($options.newRepliesCountLabel), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["resource"]))
                  ])
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_Transition, { name: "gfu-fade" }, {
        default: _withCtx(() => [
          (_ctx.showReply)
            ? (_openBlock(), _createBlock(_component_project_comment_field, {
                key: 0,
                ref: "reply",
                mode: "reply",
                class: "_mt-3",
                onNicknameRequired: $options.onNicknameRequired,
                onSubmit: $options.onReplySubmit,
                onCancel: $options.onCancel
              }, null, 8 /* PROPS */, ["onNicknameRequired", "onSubmit", "onCancel"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 16 /* FULL_PROPS */, ["class", "has-children", "has-pin-comment-action", "has-report-and-hide-action", "allow-creator-hiding-comments", "is-breakpoint-large", "can-comment", "onReply", "onNicknameRequired", "onTagSelected", "data-qa"]))
}